import React, {useRef} from 'react'

import {IconButton, Popover, ListItem} from '../index.js'
import {getMenuStyle, menuAnchorStyle, tableMenus} from './styles.js'
import t from '../../../helpers/Languages.js'
import type {PopoverRef} from '../overlays/Popover.js'

interface SelectionMenuProps {
    onAddPage: () => void
    maxHeight: number
}

/** The menu next to the select-all checkbox */
const SelectionMenu = ({onAddPage, maxHeight}: SelectionMenuProps) => {
    const popoverRef = useRef<PopoverRef>(null)

    // The Popover is placed on the button itself, so it is the anchor (a wrapper around an absolute button has no size)
    return (
        <div style={menuAnchorStyle}>
            <Popover
                style={{position: 'absolute', top: tableMenus.buttonTop, left: tableMenus.selectionMenuLeft}}
                ref={popoverRef}
                content={
                    <div style={getMenuStyle(tableMenus.selectionMenuWidth, maxHeight)}>
                        <ListItem
                            onClick={() => {
                                popoverRef.current?.close()
                                onAddPage()
                            }}
                        >
                            {t('tableAddPageToSelection')}
                        </ListItem>
                    </div>
                }
            >
                <IconButton aria-label={t('tableSelectionMenu')} aria-haspopup='menu'>
                    <i className='mdi mdi-chevron-down' />
                </IconButton>
            </Popover>
        </div>
    )
}

export default SelectionMenu
